import ProcessName from './ProcessName.jsx';

export default ProcessName;